import { IconLogout } from "@tabler/icons-react";
import React from "react";
import { toast } from "sonner";

import { Loader } from "@/components/Loader";
import { useTeam } from "@/components/providers/team";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { buttonVariants } from "@/components/ui/button";
import {
	apiClient,
	requestWithHandling,
	TypedClientApiError,
} from "@/utils/api";

export function LeaveTeamDialog({ teamID }: { teamID: string }) {
	const [isLoading, setIsLoading] = React.useState(false);
	const { refresh } = useTeam();
	return (
		<AlertDialog>
			<AlertDialogTrigger
				className={buttonVariants({
					variant: "destructive",
					size: "icon-sm",
				})}
				aria-label="Leave team"
			>
				<IconLogout className="h-4 w-4" />
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Leave Team</AlertDialogTitle>
					<AlertDialogDescription>
						Are you sure you want to leave this team? This action cannot be
						undone.
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>Cancel</AlertDialogCancel>
					<AlertDialogAction
						onClick={async () => {
							setIsLoading(true);
							try {
								await requestWithHandling<void>(() =>
									apiClient.api.userTeamsLeaveCreate({ id: teamID }),
								);
								toast.success("Team left successfully");
								await refresh();
							} catch (error) {
								toast.error("Failed to leave team", {
									description:
										error instanceof TypedClientApiError
											? error.message
											: "An unknown error occurred",
								});
							} finally {
								setIsLoading(false);
							}
						}}
						disabled={isLoading}
						className="bg-destructive hover:bg-destructive/90"
					>
						{isLoading ? <Loader /> : "Leave"}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
